import { useEffect, useRef } from "react";

export function CursorGlow() {
  const glowRef = useRef<HTMLDivElement>(null);
  const trailRef = useRef<HTMLDivElement>(null);
  const posRef = useRef({ x: -200, y: -200 });
  const trailPosRef = useRef({ x: -200, y: -200 });
  const animRef = useRef<number>(0);

  useEffect(() => {
    const glow = glowRef.current;
    const trail = trailRef.current;
    if (!glow || !trail) return;

    const onMove = (e: MouseEvent) => {
      posRef.current = { x: e.clientX, y: e.clientY };
    };

    const animate = () => {
      // Trail smoothly follows cursor with lag
      trailPosRef.current.x += (posRef.current.x - trailPosRef.current.x) * 0.08;
      trailPosRef.current.y += (posRef.current.y - trailPosRef.current.y) * 0.08;

      glow.style.transform = `translate(${posRef.current.x - 20}px, ${posRef.current.y - 20}px)`;
      trail.style.transform = `translate(${trailPosRef.current.x - 160}px, ${trailPosRef.current.y - 160}px)`;

      animRef.current = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", onMove);
    animRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(animRef.current);
    };
  }, []);

  return (
    <>
      {/* Small sharp cursor dot */}
      <div
        ref={glowRef}
        className="fixed top-0 left-0 z-[9999] pointer-events-none w-10 h-10 rounded-full"
        style={{
          background: "radial-gradient(circle, oklch(0.85 0.18 195 / 0.9) 0%, oklch(0.75 0.20 195 / 0.4) 50%, transparent 100%)",
          boxShadow: "0 0 10px oklch(0.75 0.20 195 / 0.8), 0 0 20px oklch(0.65 0.18 195 / 0.4)",
          willChange: "transform",
        }}
      />
      {/* Large soft trailing glow */}
      <div
        ref={trailRef}
        className="fixed top-0 left-0 z-[9998] pointer-events-none w-80 h-80 rounded-full"
        style={{
          background: "radial-gradient(circle, oklch(0.75 0.18 195 / 0.06) 0%, oklch(0.65 0.16 220 / 0.03) 50%, transparent 100%)",
          willChange: "transform",
          transition: "opacity 0.3s",
        }}
      />
    </>
  );
}
